import updateDesign from './updateDesign';

export default (set, get, designId, width, height) => {
  const design = get().cabinetVisualizer.designs[designId];
  const Matrix = {
    ...design.Matrix,
    Rows: height || design.Matrix.Rows,
    Columns: width,
    // Segments - Maybe not needed
  };
  set(
    updateDesign(set, get, designId, {
      Matrix
    }),
    false,
    { type: 'cabinetVisualizer/updateDesignWallSize' }
  );
};